import React from "react";
import clsx from "clsx";

import { makeStyles } from "@material-ui/styles";
import { Container } from "@material-ui/core";
import PropTypes from "prop-types";

import NavBar from "./NavBar.js";
import Topbar from "./Topbar.js";

const useStyles = makeStyles(() => ({
  container: {
    height: "100vh",
    display: "flex",
    "@media all and (-ms-high-contrast:none)": {
      height: 0, // IE11 fix
    },
  },
  content: {
    paddingTop: 64,
    height: "100%",
    width: "100%",
    paddingLeft: 188,
  },
}));

function Navigation({ children, className }) {
  const classes = useStyles();

  return (
    <>
      <Topbar />
      <NavBar />

      <div className={classes.container}>
        <div className={classes.content}>
          <Container maxWidth={false} className={clsx(className)}>
            {children}
          </Container>
        </div>
      </div>
    </>
  );
}

Navigation.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
};

export default Navigation;
